(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-grid-peekcam"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-grid]').forEach((grid) => {
    const section = grid.closest('.review-grid-section');
    const button = section ? section.querySelector('[data-see-more]') : null;
    if (!button) return;
    const perClick = parseInt(grid.dataset.perClick, 10) || 8;

    const update = () => {
      if (grid.querySelectorAll('.review-card[hidden]').length === 0) {
        button.textContent = button.dataset.doneText || 'No more reviews';
        button.disabled = true;
      }
    };

    button.addEventListener('click', () => {
      Array.from(grid.querySelectorAll('.review-card[hidden]'))
        .slice(0, perClick)
        .forEach((card) => card.removeAttribute('hidden'));
      update();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-grid-quickclean"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-grid]').forEach((grid) => {
    const section = grid.closest('.review-grid-section');
    const button = section ? section.querySelector('[data-see-more]') : null;
    if (!button) return;
    const perClick = parseInt(grid.dataset.perClick, 10) || 8;

    const update = () => {
      if (grid.querySelectorAll('.review-card[hidden]').length === 0) {
        button.textContent = button.dataset.doneText || 'No more reviews';
        button.disabled = true;
      }
    };

    button.addEventListener('click', () => {
      Array.from(grid.querySelectorAll('.review-card[hidden]'))
        .slice(0, perClick)
        .forEach((card) => card.removeAttribute('hidden'));
      update();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-grid-quietpulse"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-grid]').forEach((grid) => {
    const section = grid.closest('.review-grid-section');
    const button = section ? section.querySelector('[data-see-more]') : null;
    if (!button) return;
    const perClick = parseInt(grid.dataset.perClick, 10) || 8;

    const update = () => {
      if (grid.querySelectorAll('.review-card[hidden]').length === 0) {
        button.textContent = button.dataset.doneText || 'No more reviews';
        button.disabled = true;
      }
    };

    button.addEventListener('click', () => {
      Array.from(grid.querySelectorAll('.review-card[hidden]'))
        .slice(0, perClick)
        .forEach((card) => card.removeAttribute('hidden'));
      update();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-grid]').forEach((grid) => {
    const section = grid.closest('.review-grid-section');
    const button = section ? section.querySelector('[data-see-more]') : null;
    if (!button) return;
    const perClick = parseInt(grid.dataset.perClick, 10) || 8;

    const update = () => {
      if (grid.querySelectorAll('.review-card[hidden]').length === 0) {
        button.textContent = button.dataset.doneText || 'No more reviews';
        button.disabled = true;
      }
    };

    button.addEventListener('click', () => {
      Array.from(grid.querySelectorAll('.review-card[hidden]'))
        .slice(0, perClick)
        .forEach((card) => card.removeAttribute('hidden'));
      update();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
